export const isLiveSite = (): boolean => {
  if (typeof window !== 'undefined') {
    const { host } = window.location;
    return !(host.includes('cloud.contensis') || host.includes('localhost'));
  }

  return false;
};
